var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgManagePeopleOutline = function SvgManagePeopleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 4.82V3.135h-1.5V4.82zM14.702 4.82V3.135H13V4.82z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20.716 1.49h-6.014v5.015h6.014zm-1.399 3.616h-3.216V2.889h3.216z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.5 4.82v6.07H13V4.82z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 12.697v-1.808h-1.5v1.808zM10 10.89v1.807h1.5v-1.808zM14.702 12.697v-1.808H13v1.808z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20.716 14.505V9.49h-6.014v5.015zm-1.399-1.4h-3.216V10.89h3.216z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 20.697v-8h-1.5v8zM14.702 20.697v-1.808H13v1.808z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20.716 22.505V17.49h-6.014v5.015zm-1.399-1.4h-3.216V18.89h3.216z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.57 7.913q-.606 0-1.03-.427a1.4 1.4 0 0 1-.425-1.032q0-.604.428-1.03Q5.97 5 6.575 5t1.03.427q.423.428.424 1.033 0 .604-.428 1.029-.427.424-1.032.424M5 19.894v-4.908H4v-4.361q0-.648.462-1.11a1.51 1.51 0 0 1 1.11-.462h2q.649 0 1.11.462t.462 1.11v4.36h-1v4.91z"
  })));
};
export default SvgManagePeopleOutline;